<template>
  <div>
    <app-header>
      <template #title>
        <h1 class="d-inline me-4">Retainer</h1>
      </template>
      <template v-slot:actions></template>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'retainers.overview' }"
      >
        <a class="nav-link">Overview</a>
      </router-link>
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'retainers.invoices' }"
      >
        <a class="nav-link">Invoices</a>
      </router-link>
    </ul>

    <router-view v-if="loaded" @refresh="loadData"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { helperMethods } from "vx/modules/clients";

export default {
  data: function () {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapState("retainer", {
      retainer: "single",
    }),
  },

  mounted: function () {
    this.loadData()
  },

  methods: {
    ...helperMethods,
    ...mapActions("retainer", {
      getRetainer: "getSingle"
    }),

    loadData() {
       this.getRetainer(this.$route.params.retainer_id).then(() => {
        this.loaded = true
      })
    },
  },
};
</script>
